import { api } from "aldoo-ra/API"

const dashboardsAPI = api("store-dashboards")

/** What a card can show (metrics, tables) and the zone the scope counts in. */
export const DashboardCatalog = (scope) => dashboardsAPI({ catalog: { scope } })
/** The user's dashboards for a scope (a first one is made when there are none). */
export const ListDashboards = (scope) => dashboardsAPI({ list: { scope } })
export const SaveDashboard = (dashboard) => dashboardsAPI({ save: { dashboard } })
export const DeleteDashboard = (scope, dashboardId) => dashboardsAPI({ delete: { scope, dashboardId } })
/** Every card's figures for a range and the period it is compared with. */
export const QueryDashboard = ({ scope, range, compare, filters, cards }) => dashboardsAPI({ query: { scope, range, compare, filters, cards } })
/** The filters this user may narrow the scope by, each with its options. */
export const DashboardFilters = (scope) => dashboardsAPI({ filters: { scope } })

const advisorAPI = api("store-advisor")
/** The latest conversation with the advisor for the scope, whether it can answer, questions to start from. */
export const AdvisorStart = (scope, language) => advisorAPI({ start: { scope, language } })
/** A question, answered from the scope's figures for the dashboard it was asked from (`context`). */
export const AdvisorAsk = ({ scope, sessionId, message, context, language }) => advisorAPI({ message: { scope, sessionId, message, context, language } })
/** Closes the conversation: the next question starts a new one. */
export const AdvisorReset = (scope) => advisorAPI({ reset: { scope } })
